export const SUPPORTED_THEMES = ["default", "vtac"] as const;
